import React, { useEffect } from 'react';
import PersonalDataForm from './PersonalDataForm';
import { BOOKING_STEPS, BOOKING_CONFIRMATION_STEPS } from '../../constants';
import { bookingProcessSetStep } from '../../store/actions/bookingProcess';
import { connect } from 'react-redux';
import BookingFlow from '../BookingFlow';
import Footer from '../../components/UI/Footer/Footer';
import { bookingConfirmationReset } from '../../store/actions/bookingConfirmation';
import { FooterSpacer } from '../../components/FooterSpacer.js/FooterSpacer';

const PersonalDataComponent = props => {
    useEffect(() => {
        props.bookingConfirmationReset();
        props.bookingProcessSetStep();
        return () => {
            props.bookingConfirmationReset();
        }
    }, [])
    return (
        <React.Fragment>
            {props.isBookingConfirmationOpen ?
                <React.Fragment>
                    <BookingFlow />
                    <FooterSpacer />
                    <Footer
                        continueDisabled={true}
                        continueLbl={props.translations.label_confirm_booking}
                        backClick={props.bookingConfirmationReset}
                        nextClick={null}
                        backDisabled={props.currentStepPayment === BOOKING_CONFIRMATION_STEPS.SUCCESS || props.isSubmittingCard}
                    />
                </React.Fragment>
                :
                <PersonalDataForm />
            }
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        isBookingConfirmationOpen: state.bookingConfirmationReducer.isPopupOpen,
        isSubmittingCard: state.bookingConfirmationReducer.isSubmittingCard,
        currentStepPayment: state.bookingConfirmationReducer.currentStep,
        translations: state.settingsReducer.translations,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        bookingProcessSetStep: () => dispatch(bookingProcessSetStep(BOOKING_STEPS.PERSONAL_DATA)),
        bookingConfirmationReset: () => dispatch(bookingConfirmationReset()),
    };
};

export const PersonalDataContainer = connect(mapStateToProps, mapDispatchToProps)(PersonalDataComponent);


// WEBPACK FOOTER //
// ./src/containers/PersonalDataForm/PersonalData.js